import _classCallCheck from "D:/BuildAgent02/work/3584ffa7ff58f781/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/BuildAgent02/work/3584ffa7ff58f781/node_modules/@babel/runtime/helpers/esm/createClass.js";
import IMask from './holder.js';

/** Provides details of changing model value */
var ChangeDetails = /*#__PURE__*/function () {
  function ChangeDetails(details) {
    _classCallCheck(this, ChangeDetails);
    Object.assign(this, {
      inserted: '',
      rawInserted: '',
      tailShift: 0,
      skip: false
    }, details);
  }

  /** Aggregate changes */
  _createClass(ChangeDetails, [{
    key: "aggregate",
    value: function aggregate(details) {
      this.inserted += details.inserted;
      this.rawInserted += details.rawInserted;
      this.tailShift += details.tailShift;
      this.skip = this.skip || details.skip;
      return this;
    }

    /** Total offset considering all changes */
  }, {
    key: "offset",
    get: function get() {
      return this.tailShift + this.inserted.length;
    }
  }, {
    key: "consumed",
    get: function get() {
      return Boolean(this.rawInserted) || this.skip;
    }
  }, {
    key: "equals",
    value: function equals(details) {
      return this.inserted === details.inserted && this.tailShift === details.tailShift && this.rawInserted === details.rawInserted && this.skip === details.skip;
    }
  }], [{
    key: "normalize",
    value: /** Inserted symbols */

    /** Additional offset if any changes occurred before tail */

    /** Raw inserted is used by dynamic mask */

    /** Can skip chars */

    function normalize(prep) {
      return Array.isArray(prep) ? prep : [prep, new ChangeDetails()];
    }
  }]);
  return ChangeDetails;
}();
IMask.ChangeDetails = ChangeDetails;
export { ChangeDetails as default };